import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../../redux/actions/auth/authActions";

function LogOutCard() {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);
  const [hovered, setHovered] = useState(false);

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <div style={styles.wrapper}>
      <button
        onClick={handleLogout}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          ...styles.logoutBtn,
          color: "#ffffff",
          backgroundColor: hovered ? "rgba(211,47,47,0.18)" : "transparent",
          justifyContent: drawerOpen ? "flex-start" : "center",
          padding: drawerOpen ? "10px 12px" : "10px",
        }}
        title="Log out"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke={hovered ? "#d32f2f" : "currentColor"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        {drawerOpen && (
          <span style={{ marginLeft: 10, whiteSpace: "nowrap" }}>Log out</span>
        )}
      </button>
    </div>
  );
}

const styles = {
  wrapper: {
    marginTop: "auto",
    padding: "8px 0",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    background: "none",
    width: "100%",
    textAlign: "left",
    transition: "all 0.15s",
  },
};

export default LogOutCard;
